import React from 'react'
import styled from 'styled-components'
import { Text } from 'ui'
import CouponIcon from 'assets/icons/Coupon.svg'
import { LoveIcon } from './icons'
import { CheckBox } from './FilterModal'
import { FlexSpaceBetween, DueDate, CouponCompanyLogoWrapper } from './SharedStyledComponents'
import { CouponCardProps } from './types'
import { useCountdown } from '../../../utils/countdown'
import BlurhashImage from '../../../components/BlurhashImage'

const CheckBoxContainer = styled.div`
position: absolute;
top: 20px;
left: 20px;
display: flex;
padding: 15px;
justify-content: center;
align-items: center;
border-radius: 8px;
background: var(--Neutral-Surface-Minimal, #FFF);
opacity: 1;
transition: opacity 0.6s ease;
`

const CouponCardContainer = styled.div<{ isChecked: boolean }>`
display: flex;
width: 472px;
padding: 16px;
flex-direction: column;
gap: 12px;
border-radius: 16px;
background: var(--Neutral-Surface-Minimal, #FFF);
cursor: pointer;
border: 2px solid ${props => props.isChecked ? '#16AA40' : '#FFF'};
@media (max-width: 1081px) {
  display: flex;
width: 343px;
padding: 8px;
flex-direction: column;
align-items: flex-end;
gap: 16px;
}
`

const CouponCardImageContainer = styled.div`
width: 100%;
height: 330px;
position: relative;
overflow: hidden;
background: var(--Neutral-Surface-Light, #FFFFFF);
@media (max-width: 1081px) {
  width: 329px;
  height: 248px;
}
`


const DiscountPercentage = styled.div`
display: flex;
padding: 8px 12px;
justify-content: center;
align-items: center;
gap: 10px;
position: absolute;
top: 20px;
right: 20px;
border-radius: 8px;
background: var(--Neutral-Surface-Dark, #272727);
`

const CouponDeatilesContainer = styled.div`
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
gap: 20px;
align-self: stretch;
`

const PriceAndDateDiv = FlexSpaceBetween

export const LoveIconContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: #FFF;
  border-radius: 1000px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 998;
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.1);
  }
`

const CouponCard: React.FC<CouponCardProps> = ({ image, imageMetadata, title, subtitle, companyLogo, discountPercentage, price, liked, onToggleLiked, isChecked, onCheckboxChange, onClick, endAt }) => {
  const { timeLeft, isExpired, shouldShow } = useCountdown(endAt)

  return (
    <CouponCardContainer isChecked={isChecked} onClick={onClick}>
      <CouponCardImageContainer>
        <BlurhashImage
          src={image[0]}
          blurhash={imageMetadata?.[0]?.blurhash}
          alt={title}
          objectFit="cover"
        />
        <LoveIconContainer onClick={(e) => { e.stopPropagation(); onToggleLiked(); }}>
          <LoveIcon liked={liked} onClick={onToggleLiked} />
        </LoveIconContainer>
        <CheckBoxContainer onClick={(e) => e.stopPropagation()}>
          <CheckBox
            type='checkbox'
            checked={isChecked}
            onChange={(e) => { e.stopPropagation(); onCheckboxChange(e.target.checked); }}
          />
        </CheckBoxContainer>
        {companyLogo && (
          <CouponCompanyLogoWrapper>
            <img src={companyLogo} alt={title} />
          </CouponCompanyLogoWrapper>
        )}
        <DiscountPercentage><img src={CouponIcon} alt='coupon' /><Text size='md' weight='bold' textcolor='#FFF'>{discountPercentage}</Text> </DiscountPercentage>
      </CouponCardImageContainer>
      <CouponDeatilesContainer>
        <PriceAndDateDiv>
          <Text size='md' weight='bold' textcolor='#272727'><div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}><span>{price}</span>  <span>₪</span> </div></Text>
          {shouldShow && (
            <DueDate isExpired={isExpired}>
              <Text size='md' weight='bold' textcolor={isExpired ? 'white' : '#C80842'}>
                {isExpired ? (
                  <>הטבה הסתיימה</>
                ) : (
                  <>תוקף הטבה <span style={{ display: 'inline-block', width: '70px', fontFamily: 'monospace' }}>{timeLeft}</span></>
                )}
              </Text>
            </DueDate>
          )}
        </PriceAndDateDiv>
        <div style={{ width: '100%', minWidth: 0 }}>
          <Text size='xl' weight='normal' textcolor='#272727' textAlign='right'>{title}</Text>
          <Text
            size='lg'
            weight='normal'
            textcolor='#888888'
            style={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {subtitle}
          </Text>
        </div>
      </CouponDeatilesContainer>
    </CouponCardContainer>
  )
}

export default CouponCard   